export enum FrontEndPRStatus {
  All = "All",
  NotShippedNorReadyToShip = "Not Shipped or Ready to Ship",
  DefectRequest = "DefectRequest"
}

export interface ISearchPRParamsReq {
  status?: string;
  prId?: number;
  orderId?: number;
  fabric?: string;
  sku?: string;
  startShipDate?: string | Date;
  endShipDate?: string | Date;
  startLastPrintDate?: string | Date;
  endLastPrintDate?: string | Date;
  notShippedNorReadyToShip?: boolean;
  weekNumber?: string;
  printSlipId?: string;
  page: number;
  pageSize: number;
}

export enum PRStatus {
  Placed = "Placed",
  TFInDesign = "TFInDesign",
  ReadyToPrint = "ReadyToPrint",
  ReadyForReprint = "ReadyForReprint",
  Pulled = "Pulled",
  Printed = "Printed",
  PrintInProgress = "PrintInProgress",
  OnHold = "OnHold",
  Carrefour = "Carrefour",
  ShipReady = "ShipReady",
  Error = "Error",
  Shipped = "Shipped",
  Canceled = "Canceled",
}

export enum Fabric {
  "AL" = "AL",
  "CS" = "CS",
  "DY" = "DY",
  "GC" = "GC",
  "HT" = "HT",
  "IY" = "IY",
  "JE" = "JE",
  "KC" = "KC",
  "LI" = "LI",
  "LP" = "LP",
  "LT" = "LT",
  "MF" = "MF",
  "MI" = "MI",
  "NA" = "NA",
  "RS" = "RS",
  "SA" = "SA",
  "SC" = "SC",
  "SF" = "SF",
  "SK" = "SK",
  "SM" = "SM",
  "ST" = "ST",
  "WC" = "WC",
  "STOCK" = "STOCK",
}

export enum LocationEnum {
  Printroom = "Printroom",
  Sub = "Sublimation",
  Laser = "Laser",
  Sew = "Sew",
  Cleaning = "Cleaning",
  Shipping = "Shipping",
  PostProd = "Client-flagged",
}
export enum ProblemEnum {
  DesignRedoHT = "Design - Redo HT",
  DesignRedoTF = "Design - Redo TF",
  ProductionReprintHT = "Production - Reprint HT",
  ProductionFabric = "Production - Fabric defect",
  ProductionPrintDefect = "Production - Print defect",
  ProductionSub = "Production - Sub defect",
  ProductionLaser = "Production - Laser defect",
  ProductionSew = "Production - Sew defect",
  ProductionUnitMissing = "Production - Unit missing or lost",
  ProductionClient = "Production - Client spotted Production defect",
}

export enum CommentsEnum {
  Other = "Other (see comment)",
  FlipBack = "Flip Back",
  MissingSignature = "Missing Signature",
  NotPlacedOrScaledLikeMockup = "Not placed or scaled like mockup",
}

export interface IPRRes {
  defectNote: number;
  dueDate: string | Date;
  fabricCode: string;
  id: number;
  length: number;
  orderId: number;
  orderItemId: number;
  printCount: number;
  size: string;
  status: PRStatus;
  transferFileId: string;
  lastPrintDate: string | Date;
  orderGuid: string;
  imageUrl: string;
  version: number;
  startOfShippingWeek: string | Date;
  endOfShippingWeek: string | Date;
  weekNumber: string;
  printSlipIds: string[];
}

export interface IReportErrorReq {
  printRequestId: number;
  step: LocationEnum;
  problem: ProblemEnum;
  comment: string;
  comment1?: string;
}

export interface IHistories {
  id: number;
  guidId: string;
  comment: string;
  printRequestId: number;
  problem: ProblemEnum;
  step: string;
  status: PRStatus;
  createdDate: string | Date;
  modifiedBy: number;
  isErrorReported?: boolean;
}

export interface IPrintRequestRes {
  defectNote: number;
  modifiedDate: string;
  dueDate: string;
  fabricCode: string;
  id: number;
  length: number;
  orderId: number;
  orderItemId: number;
  printCount: number;
  size: string;
  status: string;
  transferFile: {
    id: string;
    dueDate: string;
    status: string;
    version: number;
  };
  transferFileId: string;
  imageUrl: string;
  histories: IHistories[];
  lastPrintDate: string;
  hangtagUrl: string;
  tfUrl: string;
  transferFileStatus: string;
  orderGuid: string;
  customLabelUrl: string;
  availableSizes: string[];
  weekNumber: string;
  shippingWindowLabel: string;
}

export enum ConfirmActionEnum {
  UpdateStatus,
  GenerateHangtag,
  UpdateSize
}
